import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import couterpart from 'counterpart';
import DatePicker from 'react-datepicker';
import {ToastsContainer, ToastsStore} from 'react-toasts';
import Spinner from 'react-spinner-material';

import { FaFilter } from 'react-icons/fa';
import { MdImportExport } from 'react-icons/md';
import Dialog from 'react-bootstrap-dialog';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import { Multiselect } from 'multiselect-react-dropdown';

import "react-table/react-table.css";
import "../css/style.css";

import { DATA_TYPE_SHIPPING, WO_SHIP_FROMVN } from '../constants';
import MenuComponent2 from './MenuComponent2';
import ShipProductListView from './ShipProductListView';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import UserDataService from '../services/UserDataService';
import WorkOrderDataService from '../services/WorkOrderDataService';
import MasterDataService from '../services/MasterDataService';
import AuthenticationService from '../services/AuthenticationService';
import ItemDataService from '../services/ItemDataService';
import { ICON_COLOR} from '../icon';
import queryString from 'query-string';

class ShipWorkOrderList extends Component {
  constructor () {
    super();
    
    const numOfMonths = 24;
    let fromDate = new Date(new Date().getTime() - numOfMonths*30*24*60*60*1000*3);//1 month
    fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    let toDate = new Date();
    toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);

    this.state = {
      spinnerVisible: false,
      allStatus: [],
      fromDate: fromDate,
      toDate: toDate,
      fromDeadlineDate: toDate,
      toDeadlineDate: toDate,
      deadline: '0',
      status: '0', 
      country: null, 
      customer: null, 
      orderNo: null, 
      woStatus: 0,
      woSubStatus: '2',      
      workOrders: [],
      childRefreshCount: 0,
      show: false,
      show2: false,
      show3: false,
      countryOptions:[
        // {
        //   id: "Mỹ", name: 'Mỹ'
        // },
        // {
        //   id: "Úc", name: 'Úc'
        // },
        // {
        //   id: "Mỹ QT", name: 'Mỹ QT'
        // },
        // {
        //   id: "Úc QT", name: 'Úc QT'
        // },
        // {
        //   id: "Mỹ QT Ch.Âu", name: "Mỹ QT Ch.Âu"
        // }
      ],
      selectedCountries: [],
      selectedWoStatusList: [],
      filterItemType: 3,
      urgent: 0,
      filterGhiThiep: 0,
      ghiThiep: 0
    };
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state,callback)=>{
        return;
    };
  }

  loadCountryMappings(){
    MasterDataService.retrieveCountryMappings().then(data => {
      if (data !== undefined && data !== null && data instanceof Array){
        let countryOptions = [];
        let addedCountries = {}
        for(let i=0; i< data.length; i++){
          let country = data[i].mappedInfo;
          if (addedCountries[country] !== undefined && addedCountries[country] !== null){
            continue;
          }

          countryOptions.push({
            id: country,
            name: country
          });
          addedCountries[country] = 'Y';
        }
        this.setState({ countryOptions:  countryOptions})
      } 
    });
  }     

  componentDidMount () {
    this.loadItems();
    this.loadCountryMappings();
    MasterDataService.retrieveAllStatus().then(data => {
      let statusList = [];  

      if (data !== undefined && data !== null){
        for(let i=0; i<data.length; i++){
          if (data[i].status !== WO_SHIP_FROMVN){
            continue;
          }                    
          statusList.push({
            id: data[i].status,
            name: data[i].statusDescVn
          });
        }
      }
              
      this.setState({ allStatus:  data, statusList: statusList, selectedWoStatusList: statusList}) 
    });

    let fromDate =  WorkOrderUtil.getItem("shipWorkOrders.fromDate")
    let toDate = WorkOrderUtil.getItem("shipWorkOrders.toDate")

    const values = queryString.parse(this.props.location.search);
    let numOfMonths = 12;
    if (values !== undefined && values.status !== undefined){
      numOfMonths = 24;
    }

    if (values === undefined || (values.status === undefined && values.isback === undefined)){
      sessionStorage.removeItem('shipWorkOrders.woStatus');
    }
  
    if (values === undefined || (values.status === undefined && values.isback === undefined) || fromDate === null || fromDate === undefined) {
      let backTime = 30*24*60*60*1000*numOfMonths;
      fromDate = new Date(new Date().getTime() - backTime);//1 month
      fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    }

    if (toDate === null || toDate === undefined) {
      toDate = new Date();
      toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);
    }

    // let vm = this;
    let status = WorkOrderUtil.getItem("shipWorkOrders.status");
    let sCountries = WorkOrderUtil.getItem('shipWorkOrders.selectedCountries');
    let countries = [];
    try{
      countries = JSON.parse(sCountries)
    }catch(ec){

    }

    let swoStatusList = WorkOrderUtil.getItem('shipWorkOrders.selectedWoStatusList');
    let woStatusList = [];
    try{
      woStatusList = JSON.parse(swoStatusList)
    }catch(ec){

    } 

    let deadline = WorkOrderUtil.getItem('shipWorkOrders.deadline');
    if (deadline === undefined || deadline === null){
      deadline = '0';
    }

    let byDeadline =  WorkOrderUtil.getItem('shipWorkOrders.byDeadline');  
    let fromDeadlineDate =  WorkOrderUtil.getItem('shipWorkOrders.fromDeadlineDate');
    let toDeadlineDate =  WorkOrderUtil.getItem('shipWorkOrders.toDeadlineDate');
    let sku =  WorkOrderUtil.getItem('shipWorkOrders.sku');

    let filterItemType = WorkOrderUtil.getItem("shipWorkOrders.filterItemType");
    if (filterItemType === undefined || filterItemType === null) {
      filterItemType = '3';
    }

    let ghiThiep = WorkOrderUtil.getItem("shipWorkOrders.ghiThiep");
    if (!ghiThiep) {
      ghiThiep = 0;
    }

    let urgent = WorkOrderUtil.getItem('shipWorkOrders.urgent');
    
    let filterGhiThiep = WorkOrderUtil.getItem("shipWorkOrders.filterGhiThiep");
    if (!filterGhiThiep) {
      filterGhiThiep = 0;
    }

    this.setState({ 
      fromDate:  fromDate, 
      toDate: toDate, 
      status: status, 
      country: WorkOrderUtil.getItem("shipWorkOrders.shipTo"),
      customer: WorkOrderUtil.getItem("shipWorkOrders.customer"),
      orderNo: WorkOrderUtil.getItem("shipWorkOrders.orderNo"),
      woStatus: WorkOrderUtil.getItem("shipWorkOrders.woStatus"),
      woSubStatus: WorkOrderUtil.getItem('shipWorkOrders.woSubStatus') === undefined || WorkOrderUtil.getItem('shipWorkOrders.woSubStatus') === null? 2 : WorkOrderUtil.getItem('shipWorkOrders.woSubStatus'),
      selectedCountries: countries,
      // selectedWoStatusList: woStatusList,
      deadline: deadline,
      byDeadline: byDeadline,
      fromDeadlineDate: fromDeadlineDate,
      toDeadlineDate: toDeadlineDate,
      sku: sku,
      filterItemType: filterItemType,
      urgent: urgent,
      filterGhiThiep: filterGhiThiep,
      ghiThiep: ghiThiep
    }, () => {
      this.filterWorkOrdersBy();
    });
  
  }

  toggleRow(id) {
		const newSelected = Object.assign({}, this.state.selected);
		newSelected[id] = !this.state.selected[id];
		this.setState({
			selected: newSelected,
			selectAll: 2
		});
	}

  clearSearchInfo() {
    WorkOrderUtil.removeItem("shipWorkOrders.fromDate")
    WorkOrderUtil.removeItem("shipWorkOrders.toDate")
    WorkOrderUtil.removeItem("shipWorkOrders.status")
    WorkOrderUtil.removeItem("shipWorkOrders.shipTo")
    WorkOrderUtil.removeItem("shipWorkOrders.customer")
    WorkOrderUtil.removeItem("shipWorkOrders.orderNo")
    WorkOrderUtil.removeItem("shipWorkOrders.woStatus")
    WorkOrderUtil.removeItem("shipWorkOrders.woSubStatus")
    WorkOrderUtil.removeItem("shipWorkOrders.pcode")
    WorkOrderUtil.removeItem("shipWorkOrders.personalization")
    WorkOrderUtil.removeItem('shipWorkOrders.selectedPage', 1)
    WorkOrderUtil.removeItem('shipWorkOrders.selectedRow', 1)
    WorkOrderUtil.removeItem("shipWorkOrders.selectedCountries");
    WorkOrderUtil.removeItem("shipWorkOrders.selectedWoStatusList"); 

    WorkOrderUtil.removeItem("shipWorkOrders.byDeadline"); 
    WorkOrderUtil.removeItem("shipWorkOrders.fromDeadlineDate"); 
    WorkOrderUtil.removeItem("shipWorkOrders.toDeadlineDate"); 
    WorkOrderUtil.removeItem("shipWorkOrders.deadline");
    WorkOrderUtil.removeItem("shipWorkOrders.sku");
    WorkOrderUtil.removeItem("shipWorkOrders.filterItemType");
    WorkOrderUtil.removeItem("shipWorkOrders.urgent");
    WorkOrderUtil.removeItem("shipWorkOrders.filterGhiThiep");
    WorkOrderUtil.removeItem("shipWorkOrders.ghiThiep");
  }
  saveSearchInfo(fromDate, toDate, status, shipTo, orderNo, woStatus, woSubStatus, pcode, personalization, selectedCountries, 
    selectedWoStatusList, byDeadline, fromDeadlineDate, toDeadlineDate, deadline, sku, filterItemType, urgent, filterGhiThiep, ghiThiep){
    WorkOrderUtil.saveItem("shipWorkOrders.fromDate", fromDate);
    WorkOrderUtil.saveItem("shipWorkOrders.toDate", toDate);  
    WorkOrderUtil.saveItem("shipWorkOrders.status", status);
    WorkOrderUtil.saveItem("shipWorkOrders.shipTo", shipTo);
    WorkOrderUtil.saveItem("shipWorkOrders.orderNo", orderNo);
    WorkOrderUtil.saveItem("shipWorkOrders.woStatus", woStatus);
    WorkOrderUtil.saveItem("shipWorkOrders.woSubStatus", woSubStatus);
    WorkOrderUtil.saveItem("shipWorkOrders.pcode", pcode);
    WorkOrderUtil.saveItem("shipWorkOrders.personalization", personalization);
    WorkOrderUtil.saveItem("shipWorkOrders.selectedCountries", JSON.stringify(selectedCountries));
    WorkOrderUtil.saveItem("shipWorkOrders.selectedWoStatusList", JSON.stringify(selectedWoStatusList));

    WorkOrderUtil.saveItem("shipWorkOrders.deadline", deadline);
    WorkOrderUtil.saveItem("shipWorkOrders.byDeadline", byDeadline);
    WorkOrderUtil.saveItem("shipWorkOrders.fromDeadlineDate", fromDeadlineDate);
    WorkOrderUtil.saveItem("shipWorkOrders.toDeadlineDate", toDeadlineDate);
    WorkOrderUtil.saveItem("shipWorkOrders.sku", sku);
    WorkOrderUtil.saveItem("shipWorkOrders.filterItemType", filterItemType);
    WorkOrderUtil.saveItem("shipWorkOrders.urgent", urgent);
    WorkOrderUtil.saveItem("shipWorkOrders.filterGhiThiep", filterGhiThiep);
    WorkOrderUtil.saveItem("shipWorkOrders.ghiThiep", ghiThiep);
  }

  onFilter() {
    this.clearSearchInfo();
    this.filterWorkOrdersBy();
  }  

  filterWorkOrdersBy(){   
    let fromDate = this.state.fromDate;
    let toDate = this.state.toDate;

    let byDeadline = this.state.byDeadline;
    let fromDeadlineDate = this.state.fromDeadlineDate;
    let toDeadlineDate = this.state.toDeadlineDate;
        
    let status = this.state.status;
    let woStatus = this.state.woStatus;
    let shipTo = this.state.shipTo;
    let orderNo = this.state.orderNo;
    let pcode = this.state.pcode;
    let personalization =  this.state.personalization
    let isShipped = this.state.woSubStatus
    let deadline = this.state.deadline;
    let selectedCountries = this.state.selectedCountries? this.state.selectedCountries : []
    let selectedWoStatusList =  this.state.selectedWoStatusList? this.state.selectedWoStatusList: []
    let sku = this.state.sku;
    let filterItemType = this.state.filterItemType;

    let c = this.state.childRefreshCount + 1
    let urgent = this.state.urgent;
    let filterGhiThiep = this.state.filterGhiThiep ? this.state.filterGhiThiep : 0;
    let ghiThiep = this.state.ghiThiep ? this.state.ghiThiep : 0;

    try{
      this.setState({spinnerVisible: true}, () =>{
        this.setState({ workOrders:  [] }, () => {

          if (status === undefined || status === null){
              status = "all";
          }

          if (shipTo === undefined || shipTo === null){
              shipTo = "all";
          }

          if (pcode === undefined || pcode === null){
              pcode = "";
          }        

          if (orderNo === undefined || orderNo === null){
              orderNo = "";
          }

          if (personalization === null || personalization === undefined){
              personalization = ""
          }
          
          let selectedCountryIds = [];
          if (selectedCountries){
            for(let i=0; i<selectedCountries.length; i++){
              selectedCountryIds.push(selectedCountries[i].id);
            }
          }

          let selectedWoStatusCodes = [45];
          // if (selectedWoStatusList){
          //   for(let i=0; i<selectedWoStatusList.length; i++){
          //     selectedWoStatusCodes.push(selectedWoStatusList[i].id);
          //   }  
          // }        

          let info = {
              fromDate: fromDate,
              toDate: toDate,
              status: status,
              shipTo: shipTo,
              orderNo: orderNo,
              woStatus: undefined,
              isFull: 0,
              pcode: pcode,
              personalization: personalization,
              shipCode: isShipped,
              countries: selectedCountryIds,
              woStatusList: selectedWoStatusCodes,
              deadline: deadline,
              byDeadline: byDeadline,
              fromDeadlineDate: fromDeadlineDate,
              toDeadlineDate: toDeadlineDate,
              includeImage: 0,
              sku: sku,
              filterItemType: filterItemType,
              urgent: urgent,
              ghiThiepStatus: filterGhiThiep,
              ghiThiep: ghiThiep
          };
          
          WorkOrderDataService.searchWorkOrdersBy(info)
            .then(data => {
            this.sleep(100).then(() => {this.setState({spinnerVisible: false});});
            if(data.message === undefined){
              // console.log('[retrieveWorkOrdersBy]', data);
              this.setState({ workOrders:  data, childRefreshCount: c});
              this.saveSearchInfo(fromDate, toDate, status, shipTo, orderNo, woStatus, isShipped, pcode, personalization, selectedCountries, 
                selectedWoStatusList, byDeadline, fromDeadlineDate, toDeadlineDate, deadline, sku, filterItemType,urgent, filterGhiThiep, ghiThiep);
            }else{
              this.setState({ workOrders:  [], childRefreshCount: c});
              ToastsStore.error(data.message);
            }   
          });    
        });
      });
    }catch(e){
      this.sleep(100).then(() => {this.setState({spinnerVisible: false});});
    }
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  doPackage () {
    if ((this.checkSelectedItems() === 1)) {
      alert(couterpart.translate('error_ship_items_empty'));
      return;
    }

    if ((this.checkSelectedItems() === 2)) {
      alert(couterpart.translate('error_ship_items_invalid'));
      return;
    }

    let packageDate = WorkOrderUtil.convertToyyyyMMddhhmmString(new Date());

    this.dialog.show({
        title: couterpart.translate("msg_title_confirm"),
        body: couterpart.translate("msg_package_wo_confirm"),
        actions: [
            Dialog.CancelAction(),
            Dialog.OKAction(() =>{
              try{
                this.setState({spinnerVisible: true, show: true, packageDate: packageDate}, () =>{
                  //Do something here
                });
                this.sleep(100).then(() => {this.setState({spinnerVisible: false});});        
              } catch(e) {
                  this.sleep(100).then(() => {this.setState({spinnerVisible: false});});
              }
            })
        ],
        bsSize: 'small',
        onHide: (dialog) => {
            dialog.hide()
            console.log('closed by clicking background.')
        }
    });  
  }

  changePackage () {
    if ((this.checkSelectedItems() === 1)) {
      alert(couterpart.translate('error_ship_items_empty'));
      return;
    }

    if ((this.checkSelectedItems() !== 2)) {
      alert(couterpart.translate('error_ship_items_invalid'));
      return;
    }

    let packageDate = WorkOrderUtil.convertToyyyyMMddhhmmString(new Date());

    this.dialog.show({
        title: couterpart.translate("msg_title_confirm"),
        body: couterpart.translate("msg_package_wo_change_confirm"),
        actions: [
            Dialog.CancelAction(),
            Dialog.OKAction(() =>{
              try{
                this.setState({spinnerVisible: true, show3: true, packageDate: packageDate}, () =>{
                  //Do something here
                });
                this.sleep(100).then(() => {this.setState({spinnerVisible: false});});        
              } catch(e) {
                  this.sleep(100).then(() => {this.setState({spinnerVisible: false});});
              }
            })
        ],
        bsSize: 'small',
        onHide: (dialog) => {
            dialog.hide()
            console.log('closed by clicking background.')
        }
    });  
  }

  doPackageNote () {
    if ((this.checkSelectedItems() === 1)) {
      alert(couterpart.translate('error_ship_items_empty'));
      return;
    }

    this.dialog.show({
        title: couterpart.translate("msg_title_confirm"),
        body: couterpart.translate("msg_package_wo_confirm_note"),
        actions: [
            Dialog.CancelAction(),
            Dialog.OKAction(() =>{
              try{
                this.setState({spinnerVisible: true, show2: true}, () =>{
                  //Do something here
                });
                this.sleep(100).then(() => {this.setState({spinnerVisible: false});});        
              } catch(e) {
                  this.sleep(100).then(() => {this.setState({spinnerVisible: false});});
              }
            })
        ],
        bsSize: 'small',
        onHide: (dialog) => {
            dialog.hide()
            console.log('closed by clicking background.')
        }
    });  
  }  

  savePackageInfo (){
    if (this.state.packageDate === undefined || this.state.packageDate === null || this.state.packageDate.trim().length < 6){
      alert(couterpart.translate('error_ship_date_invalid'));
      return;
    }

    if (this.state.packageNo === undefined || this.state.packageNo === null || this.state.packageNo.trim().length < 1){
      alert(couterpart.translate('error_ship_code_invalid'));
      return;
    }

    let selectedItems = [];
    for (let key in this.state.selectedWorkOrders) {
      if (this.state.selectedWorkOrders[key] === true){
        selectedItems.push(parseInt(key));
      }
    }
    WorkOrderDataService.changeShipping(selectedItems, {
      shipCode: this.state.packageNo.trim(),
      shipDate: this.state.packageDate.trim()
    }).then(data => {
      console.log('changeShipping', data);
      this.props.history.push("/shipPackages");
    });
  }

  changePackageInfo (){
    if (this.state.packageDateNew === undefined || this.state.packageDateNew === null || this.state.packageDateNew.trim().length < 6){
      alert(couterpart.translate('error_ship_date_invalid'));
      return;
    }

    if (this.state.packageNoNew === undefined || this.state.packageNoNew === null || this.state.packageNoNew.trim().length < 1){
      alert(couterpart.translate('error_ship_code_invalid'));
      return;
    }

    let selectedItems = [];
    for (let key in this.state.selectedWorkOrders) {
      if (this.state.selectedWorkOrders[key] === true){
        selectedItems.push(parseInt(key));
      }
    }
    WorkOrderDataService.changeShipping(selectedItems, {
      shipCode: this.state.packageNoNew.trim(),
      shipDate: this.state.packageDateNew.trim(),
      shipNote: this.state.packageNoteNew.trim()
    }).then(data => {
      console.log('changeShipping', data);
      this.props.history.push("/shipPackages");
    });
  }

  loadItems(){
    ItemDataService.retrieveItems().then(data =>{
      this.setState({ 
          items: data
      });
    });
  }
  
  handleSkuChange(e){
    var value = e.target.value;
    this.setState(prevState => ({                 
      sku: value                   
    }));
  }     

  renderItemList(){
    let options = this.state.items !== undefined?  this.state.items : []
    return(
        <div className="col-2">
            <input type="text" name="font" size="16" id="skus_shipWorkOrderList" 
                list="skus"
                placeholder={couterpart.translate('work_order_code')}
                defaultValue={this.state.sku}
                onChange={this.handleSkuChange.bind(this)} onKeyDown = {(e) => { e.persist(); setTimeout(() => { this.handleSkuChange(e) }, 0); }}/>
            <datalist id="skus">
                { options.map(x => <option value={x.sku} key={x.sku}>{x.sku}</option>) }
            </datalist>
        </div>          
    );                
  }  

  checkSelectedItems (){
    if ((this.state.selectedWorkOrders === undefined) || (this.state.selectedWorkOrders === null || this.state.selectedWorkOrders.length < 1)) {
      return 1
    }
    let count = 0;
    for (let key in this.state.selectedWorkOrders) {
      if (this.state.selectedWorkOrders[key] === true){
        count++;
      }
      let wo = this.state.workOrders.find(it => {
        return it.id == key 
      })

      if (wo !== undefined){
        if (wo.status !== 45 || (wo.status === 45 && wo.shipCode !== undefined && wo.shipCode !== null && wo.shipCode.trim().length > 0)){
          return 2;
        }
      }
    }

    if (count < 1){
      return 1;
    }
    return 0;
  }  

  exportExcel(){
    try
    {
      if ((this.checkSelectedItems() === 1)) {
        alert(couterpart.translate('error_selected_items_empty'));
        return;
      }

      UserDataService.retrieveNextFilename(DATA_TYPE_SHIPPING).then(res => {

        this.setState({spinnerVisible: true}, () =>{
          let selectedItems = [];
          if ((this.state.selectedWorkOrders !== undefined) && (this.state.selectedWorkOrders !== null)) {
            for (let key in this.state.selectedWorkOrders) {
              if (this.state.selectedWorkOrders[key] === true){
                selectedItems.push(parseInt(key));
              }
            }
          }
          // console.log("[selectedItems]: ", selectedItems);
          WorkOrderDataService.exportExcelForShipping(selectedItems, res.filename, res.id).then(data =>{
            const downloadUrl = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', res.filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            this.sleep(100).then(() => {this.setState({spinnerVisible: false});});    
          });
        });
      });        
    } catch(e) {
        this.sleep(100).then(() => {this.setState({spinnerVisible: false});});
    }        
  }

  getStatusDescription(status) {
    if (this.state.allStatus === undefined || this.state.allStatus === null){
        return status;
    }    
    let istatus = parseInt(status);
    let statusInfo = this.state.allStatus.find(x =>{
      return x.status === istatus;
    });
    if (statusInfo !== undefined){
      return statusInfo.statusDescVn;
    }   
    return status;    
  }

  handleFromDateChange(date){
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({                 
      fromDate: sDate                   
    });
  }

  handlePackageDateChange(date){
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({                 
      packageDate: sDate                   
    });
  }

  handlePackageDateNewChange(date){
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({                 
      packageDateNew: sDate                   
    });
  }  

  handlePackageNoChange(e){
    let value = e.target.value;
    this.setState({                 
      packageNo: value                   
    });
  }

  handlePackageNoNewChange(e){
    let value = e.target.value;
    this.setState({                 
      packageNoNew: value                   
    });
  }  

  handlePackageNoteChange(e){
    let value = e.target.value;
    this.setState({                 
      packageNote: value                   
    });    
  }

  handlePackageNoteNewChange(e){
    let value = e.target.value;
    this.setState({                 
      packageNoteNew: value                   
    });    
  }  

  handleToDateChange(date){
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({                 
      toDate: sDate                   
    });
  }

  handleFromDeadlineDateChange(date){
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({                 
      fromDeadlineDate: sDate                   
    });
  }

  handleToDeadlineDateChange(date){
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({                 
      toDeadlineDate: sDate                   
    });
  }    

  handleStatusChange(e){
    let value = e.target[e.target.selectedIndex].value;
    this.setState({                 
      status: value                   
    });
  }

  handleWoStatusChange(e){
    let value = e.target[e.target.selectedIndex].value;
    this.setState({                 
      woStatus: value,
      woSubStatus: 0     
    });
  }

  handleWoChangeStatusChange(e){
    let value = e.target[e.target.selectedIndex].value;
    this.setState({                 
      woChangedStatus: value                   
    });
  }  

  handleCountryChange(e){
    let value = e.target[e.target.selectedIndex].value;
    sessionStorage.setItem("shipWorkOrders.shipTo", value)
    this.setState({                 
      shipTo: value                   
    });
  }

  handleCustomerChange(e){
    let value = e.target.value;
    this.setState({                 
      customer: value                   
    });
  }

  handleOrderNoChange(e){
    if (e.key === 'Enter') {
      this.onFilter()
      return;
    }    
    let value = e.target.value;
    this.setState({                 
      orderNo: value                   
    });
  }

  handlePcodeChange(e){
    if (e.key === 'Enter') {
      this.onFilter()
      return;
    }    
    let value = e.target.value;
    this.setState({                 
      pcode: value                   
    });
  }

  handlePersonalizationChange(e){
    if (e.key === 'Enter') {
      this.onFilter()
      return;
    }    
    let value = e.target.value;
    this.setState({                 
      personalization: value                   
    });
  }

  handleGhiThiepClick() {
    if (this.state.ghiThiep == 1) {
      this.setState({ ghiThiep: 0 }, () => {
        
      });
    } else {
      this.setState({ ghiThiep: 1 }, () => {
        
      });
    }
  }

  renderStatusList(){
    if (this.state.allStatus === undefined || this.state.allStatus === null){
        return (<></>);
    }

    return(     
      <select onChange={this.handleStatusChange.bind(this)} 
        value={ this.state.status }>
        <option value="all">{couterpart.translate('workorder_status_all')}</option>
        { this.state.allStatus.filter(y =>{
          return y.type === 1;
        }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
      </select>
    );
  }

  handleKeyDown(e){
      if (e.key === 'Enter') {
          this.onFilter()
      }
  }  

  renderWoStatusList(){
    if (this.state.allStatus === undefined || this.state.allStatus === null){
        return (<></>);
    }
   
    return(
      <>
      <select onChange={this.handleWoStatusChange.bind(this)}
        value={this.state.woStatus}>
        <option value="all">{couterpart.translate('order_status_all')}</option>
        { this.state.allStatus.filter(y =>{
          return y.type === 2;
        }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
      </select>
      </>
    );
  }

  handleSubStatusClick (e) {
    let value = e.target.value;
    this.setState({woSubStatus: value});
  }

  handleSelectAllClick () {
    // if (this.state.selectAll === '1'){
    //   this.setState({selectAll: '0', selectedWoStatusList: [], woSubStatus: undefined});
    // } else {
    //   // let allStattus = this.state.statusList.filter(it => {
    //   //   return it.id !== 0
    //   // });
    //   let allStattus = this.state.statusList;
    //   this.setState({selectAll: '1', selectedWoStatusList: allStattus, woSubStatus: undefined});
    // }
  }

  handleDeadlineClick (e) {
    let value = e.target.value;
    this.setState({deadline: value});
  }

  handleByDeadlineClick () {
    if (this.state.byDeadline === '1'){
      this.setState({byDeadline: '0'});
    } else {
      this.setState({byDeadline: '1'});
    }
  }  

  renderWoSubStatusList(){
    if (this.state.allStatus === undefined || this.state.allStatus === null){
      return (<></>);
    }

    if (this.state.selectedWoStatusList === undefined || this.state.selectedWoStatusList === null){
      return (<></>); 
    }

    let found = this.state.selectedWoStatusList.find(it => {
      return it.id == 45 || it.id == 46 || it.id == 52;
    });

    if (found === undefined){
      return (<></>);
    }    
   
    return(
      <>
        <div className="row">
          <div className="col-12">
            <input type="radio" value="1" checked={this.state.woSubStatus === '1'? true : false }  onChange= {this.handleSubStatusClick.bind(this) } /> <label> {couterpart.translate('wo_shipped')} </label>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <input type="radio" value="2" checked={this.state.woSubStatus === '2'? true : false }  onChange= {this.handleSubStatusClick.bind(this) } /> <label> {couterpart.translate('wo_shipped_not')} </label>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <input type="radio" value="0" checked={this.state.woSubStatus === '0'? true : false }  onChange= {this.handleSubStatusClick.bind(this) } /> <label> {couterpart.translate('wo_shipped_all')} </label>
          </div>
        </div>      
      </>
    );
  }

  renderDealine(){
    return(
      <>
      <div className="row">
        <div className="col-12">
          <input type="radio" value="1" checked={this.state.deadline === '1'? true : false }  onChange= {this.handleDeadlineClick.bind(this) } /> <label> {couterpart.translate('wo_deadline')} </label>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <input type="radio" value="2" checked={this.state.deadline === '2'? true : false }  onChange= {this.handleDeadlineClick.bind(this) } /> <label> {couterpart.translate('wo_deadline_no')} </label>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <input type="radio" value="0" checked={this.state.deadline === '0'? true : false }  onChange= {this.handleDeadlineClick.bind(this) } /> <label> {couterpart.translate('wo_deadline_all')} </label>
        </div>
      </div>            
      </>
    );
  }

  renderWoChangeStatusList(){
    if (this.state.allStatus === undefined || this.state.allStatus === null){
        return (<></>);
    }
   
    return(
      <select onChange={this.handleWoChangeStatusChange.bind(this)} className="selectBox2" 
        value={this.state.woStatus}>
        <option value="all">{couterpart.translate('order_status_all')}</option>
        { this.state.allStatus.filter(y =>{
          return y.type === 2;
        }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
      </select>
    );
  }  

  exportWorkOrders (infos) {
    this.setState({
      selectedWorkOrders: infos
    });
  }

  renderProductList () {
    return (<ShipProductListView workOrders={this.state.workOrders}
      parentCallback={ this.exportWorkOrders.bind(this) } refreshCount={this.state.childRefreshCount} 
      reloadCallback={ this.filterWorkOrdersBy.bind(this)} />);
  }

  handleSetStatusChange(e){
    let value = e.target[e.target.selectedIndex].value;
    this.setState(prevState => ({                 
      newStatus: value                   
    }));
  }

  handleWorkOrderNoteChange(e){
    let newValue = e.target.value;
    this.setState(prevState => ({                 
      workOrderNote: newValue                   
    }));
  }

  changeWorkOrdersStatus(){
  }

  handleClose(){
    this.setState({ show: false });
  }

  handleClose2(){
    this.setState({ show2: false });
  }
  
  handleClose3(){
    this.setState({ show3: false });
  }

  onSelect(selectedList, selectedItem) {
    // console.log(selectedList, selectedItem);
    this.setState({
      selectedCountries: selectedList
    });
  }
  
  onRemove(selectedList, removedItem) {
    this.setState({
      selectedCountries: selectedList
    });    
  }

  onStatusSelect(selectedList, selectedItem) {
    // if (selectedItem.id === 0){
    //   this.handleSelectAllClick()
    //   return;
    // }
    // this.setState({
    //   selectedWoStatusList: selectedList
    // });
  }
  
  onStatusRemove(selectedList, removedItem) {
    // if (removedItem.id === 0){
    //   this.handleSelectAllClick()
    //   return;
    // }
    // this.setState({
    //   selectedWoStatusList: selectedList
    // });   
  }

  handleItemTypeClick(e){
    let value = e.target.value;
    this.setState({ filterItemType: value });
  }

  renderItemTypeFilter() {
    return (
      <>
        <div style={{ marginLeft: "1px" }}>
          <div>
            <label><input type="radio" value="1" onChange={this.handleItemTypeClick.bind(this)} checked={this.state.filterItemType == 1 ? true : false} /> {couterpart.translate('wo_len_da')} </label>&nbsp;&nbsp;
            <label><input type="radio" value="2" onChange={this.handleItemTypeClick.bind(this)} checked={this.state.filterItemType == 2 ? true : false} /> {couterpart.translate('wo_normal')} </label>
            <label><input type="radio" value="3" onChange={this.handleItemTypeClick.bind(this)} checked={this.state.filterItemType == 3 ? true : false} /> {couterpart.translate('wo_all')} </label>
          </div>
        </div>
      </>
    );
  }

  handleUrgentClick(e) {
    if (this.state.urgent === '1') {
      this.setState({ urgent: '0' });
    } else {
      this.setState({ urgent: '1' });
    }
  }

  handleGhiThiepFlterClick(e) {
    let value = e.target.value;
    this.setState({ filterGhiThiep: value });
  }

  renderGhiThiepFilter() {
    return (
      <>
        <div style={{ marginLeft: "1px" }}>
          <div>
            <label><input type="radio" value="1" onChange={this.handleGhiThiepFlterClick.bind(this)} checked={this.state.filterGhiThiep == 1 ? true : false} /> {couterpart.translate('da_ghi_thiep')} </label>&nbsp;&nbsp;
            <label><input type="radio" value="2" onChange={this.handleGhiThiepFlterClick.bind(this)} checked={this.state.filterGhiThiep == 2 ? true : false} /> {couterpart.translate('chua_ghi_thiep')} </label>
            <label><input type="radio" value="0" onChange={this.handleGhiThiepFlterClick.bind(this)} checked={this.state.filterGhiThiep == 0 ? true : false} /> {couterpart.translate('all_ghi_thiep')} </label>
          </div>
        </div>
      </>
    );
  }

  renderUrgent() {
    return (
      <>
        <input type="checkbox" value="1" checked={this.state.urgent === '1' ? true : false} onChange={this.handleUrgentClick.bind(this)} /> <label> {couterpart.translate('filter_urgent')} </label>
      </>
    );
  }

  renderGhiThiepButton() {
    if (!AuthenticationService.isAdmin() && !AuthenticationService.isService() && !AuthenticationService.isShipping()) {
      return (<></>)
    }

    return (
      <button className="myButton"
        onClick={this.toGhiThiep.bind(this)}>
        <MdImportExport color={ICON_COLOR} />
        &nbsp;{couterpart.translate('button_ghi_thiep')}
      </button>
    )
  }

  toGhiThiep() {
    if ((this.checkSelectedItems() === 1)) {
      alert(couterpart.translate('error_selected_items_empty'));
      return;
    }

    this.dialog.show({
      title: couterpart.translate("msg_title_confirm"),
      body: couterpart.translate("msg_to_ghi_thiep_confirm"),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          try {
            this.setState({ spinnerVisible: true }, () => {
              let selectedItems = [];
              if ((this.state.selectedWorkOrders !== undefined) && (this.state.selectedWorkOrders !== null)) {
                for (let key in this.state.selectedWorkOrders) {
                  if (this.state.selectedWorkOrders[key] === true) {
                    selectedItems.push(parseInt(key));
                  }
                }
              }

              WorkOrderDataService.toGhiThiep(selectedItems).then(data => {
                this.setState({ childRefreshCount: this.state.childRefreshCount + 1 }, () => {
                  this.sleep(100).then(() => {
                    this.setState(
                      {
                        spinnerVisible: false
                      });
                  });
                  this.filterWorkOrdersBy();
                });
              });
            });
          } catch (e) {
            this.sleep(100).then(() => {
              this.setState({
                spinnerVisible: false
              });
            });
          }
        })
      ],
      bsSize: 'small',
      onHide: (dialog) => {
        dialog.hide()
        console.log('closed by clicking background.')
      }
    });
  }


  render() {
    if (!AuthenticationService.isShipping()){
      return (<div>Unauthorized access.</div>);
    }

    return (
          <div>
              <MenuComponent2/>
              <ToastsContainer store={ToastsStore} position="bottom_center" />
              <br/>
              <div className="row">
                <div className="col-4 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px'}}>
                  <div className="row">
                    <div className="col-2">
                      <label><b>{couterpart.translate('order_date_from')}</b></label>
                    </div>
                    <div className="col-3">
                      <div className="customDatePickerWidth">
                        <DatePicker name="orderDateFrom"
                          dateFormat="MM/dd/yyyy hh:mm"              
                          selected={ WorkOrderUtil.convertToDate(this.state.fromDate)}
                          onChange={this.handleFromDateChange.bind(this)}/>
                      </div>
                    </div>
                    <div className="col-2"><label><b>{couterpart.translate('order_date_to')}</b></label></div>
                    <div className="col-3">
                      <div className="customDatePickerWidth">
                        <DatePicker name="orderDateTo"
                          dateFormat="MM/dd/yyyy hh:mm"
                          selected={ WorkOrderUtil.convertToDate(this.state.toDate)}
                          onChange={this.handleToDateChange.bind(this)}/>
                        </div>
                    </div>
                  </div>
                </div>
                <div className="col-6 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px'}}>
                  <div className="row">
                    <div className="col-3">
                      <input type="checkbox" value="1" checked={this.state.byDeadline === '1'? true : false }  onChange= {this.handleByDeadlineClick.bind(this) } /> <label> {couterpart.translate('wo_by_deadline')} </label>
                    </div>                
                    <div className="col-2">
                      <label><b>{couterpart.translate('order_date_from')}</b></label>
                    </div>
                    <div className="col-2">
                      <div className="customDatePickerWidth">
                        <DatePicker name="orderDateFrom"
                          dateFormat="MM/dd/yyyy hh:mm"              
                          selected={ WorkOrderUtil.convertToDate(this.state.fromDeadlineDate)}
                          onChange={this.handleFromDeadlineDateChange.bind(this)}/></div>
                    </div>
                    <div className="col-2"><label><b>{couterpart.translate('order_date_to')}</b></label></div>
                    <div className="col-2">
                      <div className="customDatePickerWidth">
                        <DatePicker name="orderDateTo"
                          dateFormat="MM/dd/yyyy hh:mm"
                          selected={ WorkOrderUtil.convertToDate(this.state.toDeadlineDate)}
                          onChange={this.handleToDeadlineDateChange.bind(this)}/>
                      </div>
                    </div>
                  </div>
                </div>                
                <div className="col-2">
                  <div className="row">
                    <div className="col-4"><label><b>{couterpart.translate('work_order_country')}</b></label>:</div>
                    <div className="col-6">
                      <Multiselect
                        options={this.state.countryOptions} 
                        selectedValues={this.state.selectedCountries} 
                        onSelect={this.onSelect.bind(this)} 
                        onRemove={this.onRemove.bind(this)} 
                        displayValue="name"
                        showCheckbox={true}
                      />                  
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">&nbsp;</div>
              <div className="row">
                <div className="col-1"><label style={{ width: "100%"}}><b>{couterpart.translate('work_orders')}</b></label></div>
                <div className="col-2">
                  <div className="row">
                    {/* <div className="col-3">{couterpart.translate('select_all')}&nbsp;<input type="checkbox" value="1" checked={this.state.selectAll === '1'? true : false }  onChange= {this.handleSelectAllClick.bind(this) } /></div> */}
                    <div className="col-10">
                      <Multiselect style={{ width: "100%"}} readonly
                        options={this.state.statusList} 
                        selectedValues={this.state.selectedWoStatusList} 
                        onSelect={this.onStatusSelect.bind(this)} 
                        onRemove={this.onStatusRemove.bind(this)} 
                        displayValue="name"
                        showCheckbox={false}
                        disabled 
                        singleSelect={true}
                      />
                    </div>
                  </div> 
                </div>
                <div className="col-1">{ this.renderWoSubStatusList() }</div>
                <div className="col-7">
                  <div className="row">
                    <div className='col-3'>
                      <div className='row'>
                        <div className="col-4">
                          <input type="text" defaultValue={this.state.orderNo} style={{ width: "100%"}} id="orderNo1"
                            placeholder={couterpart.translate('order_no')}
                            onChange={this.handleOrderNoChange.bind(this)} onKeyDown = {(e) => { e.persist(); setTimeout(() => { this.handleOrderNoChange(e) }, 0); }}/>
                        </div>
                        <div className="col-4">
                          <input type="text" defaultValue={this.state.pcode} style={{ width: "100%"}} id="pcode" 
                            placeholder={couterpart.translate('shop_pcode')}
                            onChange={this.handlePcodeChange.bind(this)} onKeyDown = {(e) => { e.persist(); setTimeout(() => { this.handlePcodeChange(e) }, 0); }}/>
                        </div>
                        <div className="col-4">
                          <input type="text" defaultValue={this.state.personalization} style={{ width: "100%"}} id="personalization1"
                            placeholder={couterpart.translate('work_order_personalization')}
                            onChange={this.handlePersonalizationChange.bind(this)} onKeyDown = {(e) => { e.persist(); setTimeout(() => { this.handlePersonalizationChange(e) }, 0); }}/>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-12' style={{ marginTop: "20px"}} >
                          { this.renderUrgent() }
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-12' style={{ marginBottom: "10px"}} >
                          <input type="checkbox" value={0} checked={this.state.ghiThiep == 1 ? true : false} onChange={this.handleGhiThiepClick.bind(this)} /> &nbsp;{couterpart.translate('filter_ghi_thiep')}
                        </div>
                      </div>
                    </div>
                    <div className="col-2">
                      { this.renderItemList() }
                    </div>  
                    <div className="col-2">
                      { this.renderDealine() }
                    </div>
                    <div className="col-2">
                      { this.renderItemTypeFilter() }
                    </div>
                    <div className="col-2">
                        {this.renderGhiThiepFilter() }
                    </div>
                    <div className="col-1">
                      <button className="myButton" onClick={this.onFilter.bind(this)}  style={{ width: "100%"}}><FaFilter color={ICON_COLOR}/>&nbsp;{couterpart.translate('button_filter')}</button>
                    </div>
                  </div>
                </div>                                                                
              </div>
              <div className="row">
                <div className="col-2">
                  &nbsp;
                </div>
                <div className="col-1">
                  <button className="myButton" onClick={this.exportExcel.bind(this)}><MdImportExport color={ICON_COLOR}/>&nbsp;{couterpart.translate('button_export')}</button>
                </div>
                <div className="col-2">
                  &nbsp;
                </div>                         
                <div className="col-1">
                  <button className="myButton" onClick={this.doPackage.bind(this)} style={{ width: "100%"}}><MdImportExport color={ICON_COLOR}/>&nbsp;{couterpart.translate('button_package')}</button>
                </div>
                <div className="col-1">
                  <button className="myButton" onClick={this.changePackage.bind(this)} style={{ width: "100%"}}><MdImportExport color={ICON_COLOR}/>&nbsp;{couterpart.translate('button_change_package')}</button>
                </div>
                <div className="col-1">
                  <button className="myButton" onClick={this.doPackageNote.bind(this)}  style={{ width: "100%"}}><MdImportExport color={ICON_COLOR}/>&nbsp;{couterpart.translate('button_package_note')}</button>
                </div>
                <div className="col-1">
                  { this.renderGhiThiepButton() }
                </div>                              
              </div>
              { this.renderProductList() }

              <Modal show={this.state.show} onHide={this.handleClose.bind(this)} backdrop="static">
                  <Modal.Header closeButton>
                      <Modal.Title>Package</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                      <div className="row">
                          <div className="col-4">
                              <span className="field_margin">{ couterpart.translate('wo_package_date') } : </span>
                          </div>
                          <div className="col-2">
                            <DatePicker name="packageDate" className="field_margin"
                              selected={ WorkOrderUtil.convertToDate(this.state.packageDate)}
                              dateFormat="MM/dd/yyyy hh:mm"
                              onChange={this.handlePackageDateChange.bind(this)}/>
                          </div>
                      </div>                        
                      <div className="row">
                          <div className="col-4">
                              <span className="field_margin">{ couterpart.translate('wo_package_no') } : </span>
                          </div>                        
                          <div className="col-8">
                              <input type="text" name="packageNo" className="inputBox3 field_margin"
                                onChange={this.handlePackageNoChange.bind(this)}
                              />
                          </div>
                      </div>
                      <div className="row">
                          <div className="col-4">
                              <span className="field_margin">{ couterpart.translate('wo_package_note') } : </span>
                          </div>                        
                          <div className="col-8">
                              <input type="text" name="packageNote" className="inputBox3 field_margin"
                                onChange={this.handlePackageNoteChange.bind(this)}
                              />
                          </div>
                      </div>                      
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary" onClick={this.handleClose.bind(this)}>Cancel</Button>
                    <Button variant="primary" onClick={this.savePackageInfo.bind(this)}>OK</Button>  
                  </Modal.Footer>
              </Modal>
              
              <Modal show={this.state.show2} onHide={this.handleClose2.bind(this)} backdrop="static">
                  <Modal.Header closeButton>
                      <Modal.Title>Package</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                      <div className="row">
                          <div className="col-4">
                              <span className="field_margin">{ couterpart.translate('wo_package_note') } : </span>
                          </div>                        
                          <div className="col-8">
                              <input type="text" name="packageNote" className="inputBox3 field_margin"
                                onChange={this.handlePackageNoteChange.bind(this)}
                              />
                          </div>
                      </div>                      
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary" onClick={this.handleClose2.bind(this)}>Cancel</Button>
                    <Button variant="primary" onClick={this.savePackageInfo.bind(this)}>OK</Button>  
                  </Modal.Footer>
              </Modal>

              <Modal show={this.state.show3} onHide={this.handleClose3.bind(this)} backdrop="static">
                  <Modal.Header closeButton>
                      <Modal.Title>Đổi Package</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                      <div className="row">
                          <div className="col-4">
                              <span className="field_margin">{ couterpart.translate('wo_package_date') } : </span>
                          </div>
                          <div className="col-2">
                            <DatePicker name="packageDateNew" className="field_margin"
                              selected={ WorkOrderUtil.convertToDate(this.state.packageDateNew)}
                              dateFormat="MM/dd/yyyy hh:mm"
                              onChange={this.handlePackageDateNewChange.bind(this)}/>
                          </div>
                      </div>                        
                      <div className="row">
                          <div className="col-4">
                              <span className="field_margin">{ couterpart.translate('wo_package_no') } : </span>
                          </div>                        
                          <div className="col-8">
                              <input type="text" name="packageNoNew" className="inputBox3 field_margin"
                                onChange={this.handlePackageNoNewChange.bind(this)}
                              />
                          </div>
                      </div>
                      <div className="row">
                          <div className="col-4">
                              <span className="field_margin">{ couterpart.translate('wo_package_note') } : </span>
                          </div>                        
                          <div className="col-8">
                              <input type="text" name="packageNoteNew" className="inputBox3 field_margin"
                                onChange={this.handlePackageNoteNewChange.bind(this)}
                              />
                          </div>
                      </div>                      
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary" onClick={this.handleClose3.bind(this)}>Cancel</Button>
                    <Button variant="primary" onClick={this.changePackageInfo.bind(this)}>OK</Button>  
                  </Modal.Footer>
              </Modal> 

              <Spinner size={25} spinnerColor={ICON_COLOR} spinnerWidth={2} visible={this.state.spinnerVisible} />
              <Dialog ref={(component) => { this.dialog = component }} />
          </div>      
    )
  }
}
export default withRouter(ShipWorkOrderList);